import { API_HOST } from './config';
import applePay from './methods/apple-pay/apple-pay';
import bindCard from './methods/bind-card';
import listenPayment from './methods/listen-payment';
import loadCards from './methods/load-cards';
import paymentForm, { PaymentFrame } from './methods/payment-form';
import { getDomainSfx } from './utils';
var TrustSDK = (function () {
    function TrustSDK(options) {
        if (options === void 0) { options = {}; }
        this.apiHost = API_HOST;
        this.frameOrigin = '*';
        if (options.apiHost) {
            this.apiHost = options.apiHost;
        }
        if (options.frameOrigin) {
            this.frameOrigin = options.frameOrigin;
        }
        if (!this.apiHost.endsWith("." + getDomainSfx())) {
            console.warn('Mismatch parent and API domainSfx');
        }
    }
    TrustSDK.create = function (options) {
        return new TrustSDK(options);
    };
    TrustSDK.prototype.loadCards = function (options) {
        if (options === void 0) { options = {}; }
        return loadCards(this.apiHost, options);
    };
    TrustSDK.prototype.paymentForm = function (options) {
        return paymentForm(this.apiHost, options);
    };
    TrustSDK.prototype.bindCard = function (options) {
        if (options === void 0) { options = {}; }
        return bindCard(this.apiHost, options);
    };
    TrustSDK.prototype.listenPayment = function (onMessage) {
        return listenPayment(onMessage);
    };
    TrustSDK.prototype.applePay = function () {
        return applePay({
            apiHost: this.apiHost,
            frameOrigin: this.frameOrigin
        });
    };
    return TrustSDK;
}());
export default TrustSDK;
